export default __webpack_public_path__ + "static/media/flexip-white.2e3ca0b8.svg";